import { Id, Json, JsonEntity } from '@homeleite/arch';
import { ControllerSummary } from '../controllers';
import { ProducerSummary } from '../producers';
const TYPE_ADMIN = 'admin';
const TYPE_PRODUCER = 'producer';
const TYPE_CONTROLLER = 'controller';
export abstract class User implements JsonEntity {
  constructor(
    public id = Id.gen(),
    public login = '',
    public firstName = '',
    public lastName = '',
    public email = '',
    public password = ''
  ) {}

  get fullName(): string {
    if (this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    } else {
      return this.firstName;
    }
  }

  abstract toJson(): any;

  static fromJson(json: any) {
    switch (json?.type) {
      case TYPE_ADMIN:
        return AdminUser.fromJson(json);
      case TYPE_PRODUCER:
        return ProducerUser.fromJson(json);
      case TYPE_CONTROLLER:
        return ControllerUser.fromJson(json);
    }
    throw Error(`Tipo de usuário desconhecido para ${JSON.stringify(json)}`);
  }
}

export class AdminUser extends User {
  constructor(
    id = Id.gen(),
    login = '',
    firstName = '',
    lastName = '',
    email = ''
  ) {
    super(id, login, firstName, lastName, email);
  }
  toJson() {
    return Json.to.simple(this, {
      type: TYPE_ADMIN,
    });
  }
  static fromJson(json: any) {
    return Json.from.simple(json, AdminUser);
  }
}
export class ProducerUser extends User {
  constructor(
    id = Id.gen(),
    login = '',
    firstName = '',
    lastName = '',
    email = '',
    password?: string,
    public producer: ProducerSummary = null
  ) {
    super(id, login, firstName, lastName, email, password);
  }

  toJson() {
    return Json.to.simple(this, {
      type: TYPE_PRODUCER,
      producer: Json.to.optional(this.producer),
    });
  }
  static fromJson(json: any) {
    return Json.from.simple(json, ProducerUser, {
      producer: ProducerSummary.fromJson(json?.producer),
    });
  }
}

export class ControllerUser extends User {
  constructor(
    id = Id.gen(),
    login = '',
    firstName = '',
    lastName = '',
    email = '',
    password?: string,
    public controller: ControllerSummary = null
  ) {
    super(id, login, firstName, lastName, email, password);
  }
  toJson() {
    return Json.to.simple(this, {
      type: TYPE_CONTROLLER,
      controller: Json.to.optional(this.controller),
    });
  }
  static fromJson(json: any) {
    return Json.from.simple(json, ControllerUser, {
      type: TYPE_CONTROLLER,
      controller: ControllerSummary.fromJson(json?.controller),
    });
  }
}
